class BaseRecaptchaInstance {
  execute = (action) => { throw new Error('not implemented'); };
  getSiteKey = () => { throw new Error('not implemented'); };
  hideBadge = () => { throw new Error('not implemented'); };
  showBadge = () => { throw new Error('not implemented'); };
};

export default BaseRecaptchaInstance;
